import { BuiSection } from "@btnet/blueprint-components";
import { cn } from "@btnet/utilities-core";

import {
  type IBTSectionHeaderProps,
  type IBTSectionProps,
} from "./BTSection.types";

/**
 * BTSection - an app-facing wrapper around `BuiSection` with app-specific styling hooks.
 *
 * Compose with `BTSection.Header` for a header row; anything else is passed as children.
 * @param props - The component props.
 * @param props.className - Additional CSS class names.
 * @param props["data-testid"] - Test ID for the container.
 */
const BTSectionComponent = (props: IBTSectionProps) => {
  return <BuiSection {...props} className={cn("BTSection", props.className)} />;
};

/**
 * BTSection.Header - a header row for a `BTSection`.
 *
 * An app-facing wrapper around `BuiSection.Header` with app-specific styling hooks.
 * @param props - The component props.
 * @param props.className - Additional CSS class names.
 * @param props["data-testid"] - Test ID for the header.
 */
const BTSectionHeader = (props: IBTSectionHeaderProps) => {
  return (
    <BuiSection.Header
      {...props}
      className={cn("BTSectionHeader", props.className)}
    />
  );
};

/**
 * BTSection - an app-facing wrapper around `BuiSection` with app-specific styling hooks.
 *
 * Compose with `BTSection.Header` for a header row; anything else is passed as children.
 * @param props - The component props.
 * @param props.className - Additional CSS class names.
 * @param props["data-testid"] - Test ID for the container.
 */
export const BTSection = Object.assign(BTSectionComponent, {
  /**
   * BTSection.Header - a header row for a `BTSection`.
   *
   * An app-facing wrapper around `BuiSection.Header` with app-specific styling hooks.
   * @param props - The component props.
   * @param props.className - Additional CSS class names.
   * @param props["data-testid"] - Test ID for the header.
   */
  Header: BTSectionHeader,
});
